import { render } from "./Taginput.vue?vue&type=template&id=2f6aef79"
import script from "./Taginput.vue?vue&type=script&lang=js"
export * from "./Taginput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__